import React from "react";
import axios from "axios";
import { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import AsyncSelect from 'react-select/async';
import { Button, Icon } from "semantic-ui-react";
import { useMyGlobal } from "./GlobalData";
import { useRef } from "react";
import { Toast } from "./Toast";

const InfoCustomerForm = ({ cart, customerId, isCompletedInputInfo, setIsCompletedInputInfo }) => {
    const { token } = useMyGlobal()
    const [infoName, setInfoName] = useState('')
    const [infoEmail, setInfoEmail] = useState('')
    const [infoPhone, setInfoPhone] = useState('')
    const [isLoadingInputInfo, setIsLoadingInputInfo] = useState(false)

    const handleReset = () => {
        setInfoName("");
        setInfoEmail("");
        setInfoPhone("");
        setIsCompletedInputInfo(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault()
        const param = new URLSearchParams()
        param.append('info_name', infoName)
        param.append('info_email', infoEmail)
        param.append('info_phone', infoPhone)
        param.append('id_order', cart.summary?.order_id)
        param.append('id_customer', customerId)
        setIsCompletedInputInfo(false)
        setIsLoadingInputInfo(true)
        axios({
            method: "POST",
            url: `${global.SRV}api_rudrunner/controler/customer.php/?index=19`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
            data: param
        })
            .then((response) => {
                if (response.data.state === 200) {
                    setIsCompletedInputInfo(true);
                } else {
                    console.log(response.data);
                    Toast.fire({
                        icon: 'warning',
                        title: response.data.message ?? "Unknown Error Occurred"
                    })
                }
            })
            .catch((err) => {
                Toast.fire({
                    icon: 'warning',
                    title: 'Unknown Error Occurred'
                })
                console.log(err)
            })
            .finally(() => {
                setIsLoadingInputInfo(false)
            })
    }

    return (
        <section>
            <Form onSubmit={(e) => handleSubmit(e)}>
                <>
                    <Row className="mb-3">
                        <Col sm={12} md={12}>
                            <Form.Group>
                                <Form.Label>Info Customer Name</Form.Label>
                                <Form.Control disabled={isLoadingInputInfo} type="text" maxLength={22} minLength={3} placeholder="Info Customer Name" value={infoName}
                                    onChange={(e) => {
                                        setInfoName(e.target.value)
                                        setIsCompletedInputInfo(false)
                                    }} />
                                <Form.Text>Max character (22)</Form.Text>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col sm={12} md={12}>
                            <Form.Group>
                                <Form.Label>Info Customer Email</Form.Label>
                                <Form.Control disabled={isLoadingInputInfo} type="text" minLength={3} placeholder="Info Customer Email" value={infoEmail}
                                    onChange={(e) => {
                                        setInfoEmail(e.target.value)
                                        setIsCompletedInputInfo(false)
                                    }} />
                                <Form.Text>Min character (3)</Form.Text>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col sm={12} md={12}>
                            <Form.Group>
                                <Form.Label>Info Customer Phone</Form.Label>
                                <Form.Control disabled={isLoadingInputInfo} type="number" maxLength={15} minLength={10} placeholder="Info Number" value={infoPhone}
                                    onChange={(e) => {
                                        setInfoPhone(e.target.value)
                                        setIsCompletedInputInfo(false)
                                    }} />
                            </Form.Group>
                        </Col>
                    </Row>
                </>
                <Row>
                    <Col sm={12} md={12} className="d-flex justify-content-end gap-2">
                        <Button
                            type="button"
                            size="large"
                            color="black"
                            icon="eraser"
                            disabled={isLoadingInputInfo}
                            onClick={handleReset}
                        />
                        <Button loading={isLoadingInputInfo} floated="right" size="large" color="orange" type="submit" icon="save" />
                    </Col>
                </Row>
            </Form>
        </section>
    )
}

export default InfoCustomerForm;